/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useState } from 'react';
import edit from '../../../../../assets/img/icons/edit.png';
import loader from '../../../../../assets/img/icons/TizetiLoaderColored.gif';
import { NoItemRow } from '../../../../../utils/loader/loadingHelper';
import UpdateAmbassadorsStatus from './UpdateAmbassadorsStatus';

const ExpressWifiAmbassadorsSignUpsTable = ({ items, isLoading }) => {
  const colSpan = '8';
  const [request, setRequest] = useState({
    ambassadors_name: '',
    status: '',
    ambassadors_phone: '',
    sign_ups: '',
  });
  const getRequest = (item) => setRequest(item);

  const tableData =
    items && items.length ? (
      items.map((item, i) => {
        return (
          <tr className="" key={i}>
            <td>{i + 1}</td>
            <td>{item.ambassadors_name}</td>
            <td>{item.ambassadors_phone}</td>
            <td>{item.status}</td>
            <td>{item.sign_ups}</td>
            <td>
              <div className="d-flex">
                <button
                  type="submit"
                  className="mx-1 noBorder"
                  data-toggle="modal"
                  data-placement="left"
                  data-target="#updateStatus"
                  onClick={() => getRequest(item)}
                >
                  <span className="view">
                    <img src={edit} alt="" data-toggle="tooltip" data-placement="left" title="Edit" />
                  </span>
                </button>
              </div>
            </td>
            <UpdateAmbassadorsStatus request={request} />
          </tr>
        );
      })
    ) : (
      <NoItemRow colSpan={colSpan} text="There are no records" />
    );
  return (
    <div className="card x-panel mt-2 px-0">
      <div className="table-responsive content col-12 px-1">
        <table className="table">
          <thead>
            <tr className="">
              <th>#</th>
              <th>Name</th>
              <th>Phone Number</th>
              <th>Status</th>
              <th>Sign Ups</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td className="text-center">
                  <img src={loader} alt="loading gif" />
                </td>
              </tr>
            ) : (
              tableData
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExpressWifiAmbassadorsSignUpsTable;
